"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var ConfirmationMainContentStyles_1 = require("./ConfirmationMainContentStyles");
var MySummaryExpanded_1 = require("../mySummaryExpanded/MySummaryExpanded");
var ConfirmationMainContent = function (_a) {
    var children = _a.children;
    var style = ConfirmationMainContentStyles_1.default();
    return (<core_1.Container>
      <core_1.Box className={style.confirmationWrapper}>
        <core_1.Box className={style.mainContent}>{children}</core_1.Box>
      </core_1.Box>
      <MySummaryExpanded_1.default />
    </core_1.Container>);
};
exports.default = ConfirmationMainContent;
